import React from 'react'
import { TtButton, TtButtonGroup, TtFlavorContext, TtIcon } from '@23/react'
import classnames from 'classnames'
import {
  setParticipantSelectedInMixedMode,
  toggleTrayMixedMode,
  useIsMixedModeActive,
  useParticipantIdSelectedInMixedMode,
} from '../../../../firebase/hooks/useMixedMode'
import { MixedModeParticipantListPopOver } from '../MixedModeParticipantSelector/MixedModeParticipantListPopOver'

const MixedModeTrigger = () => {
  const participantSelectedInMixedMode = useParticipantIdSelectedInMixedMode()
  const isMixedModeActive = useIsMixedModeActive()

  return (
    <div
      className={classnames('selectable-container', 'mixed-mode-btn-group')}
      data-selected={isMixedModeActive}
    >
      <TtFlavorContext flavor="webinars">
        <TtButtonGroup>
          <MixedModeParticipantListPopOver
            onConfirmClick={setParticipantSelectedInMixedMode}
          />

          <TtButton
            color="secondary"
            size="small"
            disabled={!participantSelectedInMixedMode}
            variant={!participantSelectedInMixedMode ? 'ghost' : 'default'}
            onClick={toggleTrayMixedMode}
          >
            <TtIcon
              className={classnames('mixed-mode-icon', {
                disabled: !participantSelectedInMixedMode,
              })}
              style={{
                color: isMixedModeActive ? '#1ec95b' : '#fff',
              }}
              library="one/webinars"
              name="mixed-mode"
            />
          </TtButton>
        </TtButtonGroup>
      </TtFlavorContext>
    </div>
  )
}

export { MixedModeTrigger }
